import { configureStore } from "@reduxjs/toolkit";
import tabReducer from "./tab/tabSlice.ts";
import { findUrl } from "../utilities/findurl.js";
import clientReducer from "./tab/clientSlice.ts";

export const store = configureStore({
  reducer: {
    tab: tabReducer,
    client: clientReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      thunk: {
        extraArgument: {
          baseUrl: findUrl(), // ✅ inject once when store initializes
        },
      },
    }),
});

// Types for TypeScript
export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
export type ThunkExtra = { baseUrl: string };